module.exports = __webpack_public_path__ + "img/img_12.5feb32ba.png";